module.exports = __webpack_public_path__ + "img/co.eefa6c2c.svg";